module.exports = __webpack_public_path__ + "k.no2.4d26242e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/k.no2.jpg
// module id = 7hID
// module chunks = 0